<template>
  <div
    :class="[
      'right-sidebar',
      { updating: isUpdating, 'no-close-btn': !isCloseBtnVisible },
      ...cssClasses
    ]"
    :data-testing="dataTesting"
  >
    <slot name="additional-content"></slot>

    <div class="sidebar">
      <slot name="expand-btn"></slot>
      <div class="sidebar-top">
        <slot name="title"></slot>
        <slot name="dropdown"></slot>
        <button
          v-if="isCloseBtnVisible"
          type="button"
          class="close-btn btn-3"
          title="close"
          aria-label="close"
          @click="$emit('closeSidebar')"
          :data-testing="closeBtnDataTesting"
        >
          <SVGIcon :path="mdiClose" type="is-white" :size="24" />
        </button>
      </div>

      <div class="right-sidebar-body no-sticky-buttons">
        <slot name="body"></slot>
      </div>
    </div>

    <slot name="modals"></slot>
  </div>
</template>
<script lang="ts" setup>
import { mdiClose } from "@mdi/js";
import { PropType } from "vue";

defineProps({
  isUpdating: {
    type: Boolean,
    default: false,
    required: false
  },
  isCloseBtnVisible: {
    default: true,
    required: false,
    type: Boolean
  },
  dataTesting: {
    type: String,
    required: false,
    default: ""
  },
  closeBtnDataTesting: {
    type: String,
    required: false,
    default: "close-assets-sidebar-btn"
  },
  cssClasses: {
    type: Array as PropType<string[]>,
    required: false
  }
});
</script>
<style lang="scss" scoped></style>
